type ErrorArgs = {
  message: string;
  name: string;
  status?: number;
  errors?: unknown;
  detail?: unknown;
};

export default class ApiError extends Error {
  status: number;
  errors: unknown;
  detail?: unknown;

  constructor(args: ErrorArgs) {
    super(args.message);

    this.name = args.name;
    this.status = args.status;
    this.errors = args.errors;
    this.detail = args.detail;
  }
}
